// extracted by mini-css-extract-plugin
export var stat = "styles-module--stat--LXEmY";
export var stat_list = "styles-module--stat_list--2Js3v";
export var jsAnimInit = "styles-module--jsAnimInit--2xyuh";
export var statitem_number = "styles-module--statitem_number--1wtec";